import { connect } from 'react-redux';
import View from './AllPlanEditsView';
import { goalId as selectedGoalId } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { setCurrentViewId, removeWhatIfs, fetchGoalWhatIfData } from '../WhatIfsActions';
import { appliedWhatIfsSelector, numberOfEditsSelector } from './AllPlanEditsSelector';
import { nullableUrlSelector, nullableFpIdSelector, loading } from '../WhatIfsSelector';
import { isNumeric, createCustomPropType } from '../../../js/app/react/validators';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  whatIfs: appliedWhatIfsSelector(state, ownProps),
  url: nullableUrlSelector(state, ownProps),
  numberOfEdits: numberOfEditsSelector(state, ownProps),
  loading: loading(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  setCurrentViewId: (clientId, goalId, viewId) => (event) => {
    event.stopPropagation();
    dispatch(setCurrentViewId(clientId, goalId, viewId));
  },
  removeAllWhatIfs: (clientId, fpId, goalId, url, appliedWhatIfs) => (event) => {
    if (appliedWhatIfs.length === 0) {
      return;
    }
    event.stopPropagation();
    dispatch(removeWhatIfs(clientId, fpId, goalId, url, appliedWhatIfs.map(({ key }) => key)));
  },
  removeWhatIf: (clientId, fpId, goalId, url, whatIf) => (event) => {
    event.stopPropagation();
    dispatch(removeWhatIfs(clientId, fpId, goalId, url, [whatIf.key]));
  },
  closeActiveEdits: (clientId, goalId) => () => {
    dispatch(setCurrentViewId(clientId, goalId, null));
  },
  fetchData: (clientId, fpId, goalId, url) => {
    dispatch(fetchGoalWhatIfData(clientId, fpId, goalId, url));
  },
});

const AllPlanEditsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

AllPlanEditsContainer.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default AllPlanEditsContainer;
